import * as React from 'react';

export function AddAdminModal(props: AddAdminModalProps): JSX.Element {
  return <>
    <div className='modal is-active'>
      <div
        className='modal-background'
        onClick={() => props.onCancel()}
      />
      <div className='modal-card'>
        <header className='modal-card-head'>
          <p className='modal-card-title'>
            Add admin user
          </p>
          <button
            className='delete'
            aria-label='close'
            onClick={() => props.onCancel()}
          />
        </header>
        <section className='modal-card-body'>
          <form
            action='/admin/add_admin_user'
            method='post'
            id='invite-user-form'
          >
            <input type='hidden' name='redirectUrl' value={props.redirectUrl} />
            <div className='card-content'>
              <div className='field'>
                <p className='control has-icons-left has-icons-right'>
                  <input
                    className='input'
                    name='firstName'
                    required
                    type='text'
                    placeholder='First name'
                  />
                  <span className='icon is-small is-left'>
                    <i className='fas fa-user'></i>
                  </span>
                </p>
              </div>
              <div className='field'>
                <p className='control has-icons-left has-icons-right'>
                  <input
                    className='input'
                    name='lastName'
                    required type='text'
                    placeholder='Last name'
                  />
                  <span className='icon is-small is-left'>
                    <i className='fas fa-user'></i>
                  </span>
                </p>
              </div>
              <div className='field'>
                <p className='control has-icons-left has-icons-right'>
                  <input
                    className='input'
                    name='email'
                    required
                    type='text'
                    placeholder='Email'
                  />
                  <span className='icon is-small is-left'>
                    <i className='fas fa-envelope'></i>
                  </span>
                </p>
              </div>
              <div className='select'>
                <select name='adminLevel' required>
                  <option value=''>Admin Level</option>
                  <option value='organization'>Organization</option>
                  <option value='system'>System</option>
                </select>
              </div>
            </div>
          </form>
        </section>
        <footer className='modal-card-foot'>
          <button className='button is-success' form='invite-user-form' type='submit'>Add</button>
          <button className='button' onClick={() => props.onCancel()}>Cancel</button>
        </footer>
      </div>
    </div>
  </>;
}

type AddAdminModalProps = {
  redirectUrl: string;
  onCancel: () => void;
};